module.exports = __webpack_public_path__ + "static/media/headbanner1.4bcd9825.mp4";